// frontend/src/components/layouts/ContactButtons.js
// frontend/src/components/layouts/ContactButtons.js
import React from 'react';

const ContactButtons = () => {
  const openWhatsApp = () => {
    const phoneNumber = "916364749404";
    const message = encodeURIComponent(
      "Hello Meat Buddy Team, We visited your website. We would like to place an order. Can you respond?"
    );
   
    window.open(
      `https://api.whatsapp.com/send?phone=+${phoneNumber}&text=${message}`,
      '_blank'
    );
  };

  const callPhone = () => {
    window.location.href = "tel:+916364749404";
  };

  return (
    <>
      <div className="fixed bottom-8 right-6 flex flex-col gap-4 z-[1000]">
        {/* Phone Button */}
        <div className="flex flex-col items-center">
          <button
            onClick={callPhone}
            className="contact_icon phone_icon"
            aria-label="Call us"
          >
            <i className="fa-solid fa-phone text-white"></i>
          </button>
          <p className="text_icon">Call us</p>
        </div>

        {/* WhatsApp Button */}
        <div className="flex flex-col items-center">
          <button
            onClick={openWhatsApp}
            className="contact_icon whatsapp_icon"
            aria-label="Chat with us on WhatsApp"
          >
            <i className="fa-brands fa-whatsapp text-white"></i>
          </button>
          <p className="text_icon">Chat with us</p>
        </div>
      </div>

      <style jsx>{`
        .contact_icon {
          width: 45px;
          height: 45px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          box-shadow: 2px 2px 3px #999;
          cursor: pointer;
          border: none;
          position: relative;
        }

        .whatsapp_icon {
          background-color: #25d366;
        }

        .phone_icon {
          background-color: #0080FF;
        }

        .contact_icon i {
          font-size: 20px;
          z-index: 1;
        }

        .contact_icon::before {
          content: "";
          position: absolute;
          z-index: 0;
          left: 50%;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
          display: block;
          width: 45px;
          height: 45px;
          border-radius: 50%;
          animation: pulse-border 1500ms ease-out infinite;
        }

        .whatsapp_icon::before {
          background: #25d366;
        }

        .phone_icon::before {
          background: #0080FF;
        }

        @keyframes pulse-border {
          0% {
            transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);
            opacity: 1;
          }
          100% {
            transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1.5);
            opacity: 0;
          }
        }

        .text_icon {
          margin-top: 4px;
          color: #707070;
          font-size: 11px;
        }
      `}</style>
    </>
  );
};

export default ContactButtons;